import { Grid, Typography } from '@mui/material';
import TableCell from '~/components/ListCardTable/TableCell';
import { styles } from '../../styles';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion';

interface IQuestionnaireRowProps {
  index: number;
  question: string;
  showDefaultError?: boolean;
}

export const QuestionnaireRow = ({ index, question, showDefaultError }: IQuestionnaireRowProps) => {
  return (
    <Grid container sx={styles.row}>
      <TableCell title="№" sx={{ justifyContent: 'center' }} size={0.5}>
        <Typography variant="body1">{index + 1}</Typography>
      </TableCell>
      <TableCell
        title="Інформація про зв'язки клієнта банку із державою, що здійснює збройну агресію проти України"
        size={9.5}
      >
        <Typography variant="body1" sx={styles.tableText}>
          {question}
        </Typography>
      </TableCell>
      <TableCell
        title="Варіант відповіді"
        size={2}
        sx={{ justifyContent: 'center', minHeight: 55 }}
      >
        <FormYesNoQuestion
          name={`questionnaire.question${index + 1}`}
          containerStyles={() => ({ alignItems: 'center' })}
          showDefaultError={showDefaultError}
        />
      </TableCell>
    </Grid>
  );
};
